<div class="dashboard">

  <main class="main-content">
   
    <section class="welcome-section">
      <h1>Welcome to the Admin Panel</h1>
      <p>
        Transforming Energy Ecosystems: Intelligent Utility Management for a
        Sustainable Tomorrow. Streamline operations, optimize resources, and
        drive impactful energy solutions with seamless integration and
        innovation
      </p>

      <div class="action-buttons">
        <button class="btn btn-primary"  (click)="addUtility()">Add a Utility</button>
        <button class="btn btn-secondary" (click)="viewUtilities()">View and Configure Utilities</button>
      </div>
    </section>

    <section class="metrics-grid">
      <div class="metric-card">
        <div class="metric-value">{{utility_count}}</div>
        <h3>Total Licenses</h3>
        <p>
          Track the number of active licenses issued to utilities, enabling
          efficient energy management and compliance with regulatory standards.
        </p>
        <div class="card-border"></div>
      </div>

      <div class="metric-card">
        <div class="metric-value">{{utility_count}}</div>
        <h3>Total Utilities</h3>
        <p>
          Explore the expanding network of utilities integrated with Hygge
          Energy. Each utility represents a partnership driving innovation in
          the energy sector.
        </p>
        <div class="card-border"></div>
      </div>

      <div class="metric-card">
        <div class="metric-value">{{users_count}}</div>
        <h3>Total Users</h3>
        <p>
          Monitor the growing community of users benefiting from Hygge Energy's
          platform. Every user signifies increased adoption of sustainable
          energy.
        </p>
        <div class="card-border"></div>
      </div>

      <div class="small-metrics">
        <div class="metric-card stats-card">
          <div class="stat-item">
            <h3>Total Installed Capacity</h3>
            <div class="stat-value">{{total_installed_capacity}} kWh</div>
          </div>
          <div class="card-border"></div>
        </div>
        <div class="metric-card stats-card">
          <div class="stat-item">
            <h3>Total Energy Traded</h3>
            <div class="stat-value">{{total_traded_energy}} kWh</div>
          </div>
          <div class="card-border"></div>
        </div>
      </div>
    </section>
  </main>
</div>